export const useClipboardDivMatcher = () => {
  return (node: any, delta: any) => {
    if (
      node.nodeType === 1 && // Node.ELEMENT_NODE
      node.getAttribute("data-page-break") === "true"
    ) {
      return new delta.constructor().insert({ pageBreak: true });
    }
    return delta;
  };
};
